import FilterValueDTO = App.Data.Explorer.Filter.FilterValueDTO;

/** Place here any granularity value builders */
export namespace GranularityBuilders {
	/**
	 * Generates time slots for minute-based intervals
	 * @param intervals - The minute interval (1, 5, 10, 15, 30, 60, 360)
	 * @param initial - Initial filter values
	 * @returns Array of filter value DTOs
	 */
	export function Minutes(
		intervals: number,
		initial: FilterValueDTO[]
	): FilterValueDTO[] {
		const slots: FilterValueDTO[] = [];
		switch (intervals) {
			case 1: {
				// HACK: We need to change this anyway some day
				// Special case for 1min - show just minutes within an hour (0-59)
				for (let i = 0; i < 60; i++) {
					slots.push({
						id: i,
						level: null,
						selection_depth: null,
						model: null,
						label: i.toString().padStart(2, "0"),
					});
				}
				break;
			}
			default: {
				// Normal case - show intervals throughout the day
				const totalMinutes = 24 * 60;
				const totalSlots = totalMinutes / intervals;

				for (let i = 0; i < totalSlots; i++) {
					const minutes = i * intervals;
					const hours = Math.floor(minutes / 60);
					const mins = minutes % 60;

					const formattedHours = hours.toString().padStart(2, "0");
					const formattedMinutes = mins.toString().padStart(2, "0");
					const text = `${formattedHours}:${formattedMinutes}`;

					slots.push({
						id: i,
						level: null,
						selection_depth: null,
						model: null,
						label: text,
					});
				}

				break;
			}
		}

		if (initial && initial.length > 0) {
			const existingIds = new Set(slots.map((slot) => slot.id));
			for (const item of initial) {
				if (!existingIds.has(item.id)) {
					slots.push(item);
				}
			}
		}

		return slots;
	}
}
